import { Navigate } from 'react-router-dom';
import { lazy } from 'react';

const MarketingPage = lazy(() => import('../pages/MarketingPage'));
const FeaturesPage = lazy(() => import('../pages/FeaturesPage'));
const GuidePage = lazy(() => import('../pages/GuidePage'));
const FaqPage = lazy(() => import('../pages/FaqPage'));
const BlogPage = lazy(() => import('../pages/BlogPage'));
const PrivacyPage = lazy(() => import('../pages/PrivacyPage'));
const TermsPage = lazy(() => import('../pages/TermsPage'));
const WelcomePage = lazy(() => import('../pages/WelcomePage'));
const DashboardPage = lazy(() => import('../pages/DashboardPage'));
const InstallPage = lazy(() => import('../pages/InstallPage'));
const ProvisioningPage = lazy(() => import('../pages/ProvisioningPage'));

import AppLayout from './AppLayout';

// Public routes — rendered inside AppLayout
const publicChildren = [
    { index: true, element: <MarketingPage /> },
    { path: '/guide', element: <GuidePage /> },
    { path: '/faq', element: <FaqPage /> },
    { path: '/features', element: <FeaturesPage /> },
    { path: '/blog', element: <BlogPage /> },
    { path: '/privacy', element: <PrivacyPage /> },
    { path: '/terms', element: <TermsPage /> },
    { path: '/install', element: <InstallPage /> },
];

// Authenticated routes inside AppLayout (AppAppBar via AppLayout)
const authenticatedChildren = [
    { path: '/welcome', element: <WelcomePage /> },
    { path: '/provisioning', element: <ProvisioningPage /> },
];

export const getRoutes = (isSignedIn) => [
    {
        path: '/',
        element: <AppLayout />,
        children: [...publicChildren, ...(isSignedIn ? authenticatedChildren : [])],
    },
    // Dashboard is standalone — has its own AppAppBar, no AppLayout wrapper
    ...(isSignedIn ? [{ path: '/dashboard', element: <DashboardPage /> }] : []),
    {
        path: '*',
        element: <Navigate to="/" />,
    },
];
